import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { setPdfJob } from 'src/reducers/reports/notificationOfBaseAmountRevisionAsync';
import { PAY_REPORTS_CREATE_FORM } from 'src/constants/FormNames';
import PdfCreateModal from '../components/PdfCreateModal';

const PdfCreateForm = reduxForm({
  form: PAY_REPORTS_CREATE_FORM
})(PdfCreateModal);

const mapDispatchToProps = (dispatch, ownProps) => ({
  setPdfJob: () => {
    dispatch(setPdfJob(ownProps.revisionYear, ownProps.hideModal));
  }
});

export default connect(null, mapDispatchToProps)(PdfCreateForm);
